module.exports = __webpack_public_path__ + "img/partyterminal2.6c1febfa.png";